import { Elm } from '../../elm/Carwow/StockSearch.elm'

import '../render_html'
import elmElement from '../elm_element'
import navigationPorts from '../navigation'
import modalPorts from '../modal'
import chipDropdownPorts from '../chip_dropdown'
import analyticsPorts from '../analytics'
import initFormValidation from '../helpers/form_validation'
import Cookie from 'js-cookie'

elmElement('carwow-stock-search', Elm.Carwow.StockSearch, {
  bugsnagRedactFlags: [],

  setupPorts (ports) {
    navigationPorts(ports)
    modalPorts(ports, {
      allowTouchMove: el => el.matches('.input-range')
    })
    analyticsPorts(ports)
    chipDropdownPorts(ports)
    updateLocationPorts(ports)

    ports.scrollTo.subscribe((id) => {
      const scrollElement = document.getElementById(id)
      const scrollElementInViewport = scrollElement.getBoundingClientRect().top >= 0

      if (scrollElement && !scrollElementInViewport) {
        scrollElement.scrollIntoView(true)
      }
    })
  },

  mapFlags (flags) {
    const userPostcode = Cookie.get('user_postcode') || null
    const showLocationChip = JSON.parse(flags.showLocationChip)

    return Object.assign(flags, {
      dealRelativePath: flags.dealRelativePath || null,
      dealRootPath: flags.dealRootPath || null,
      stockSale: JSON.parse(flags.stockSale),
      filterOptions: JSON.parse(flags.filterOptions),
      windowOrigin: window.location.origin,
      windowPath: window.location.pathname,
      showPriceConfidence: flags.showPriceConfidence || 'false',
      showLocationChip,
      userPostcode: showLocationChip ? userPostcode : null,
      searchParams: getAllSarchParams()
    })
  }
})

if (window.Carwow && window.Carwow.registerBugsnagVolumeError) {
  window.Carwow.registerBugsnagVolumeError((error) => {
    const component = error.errorClass.includes('carwow-stock-search')
    const messages = [
      'Http.Timeout @',
      'Http.BadStatus: 400 @',
      'Http.BadStatus: 401 @',
      'Http.BadStatus: 404 @',
      'Http.BadStatus: 503 @',
      'Http.BadStatus: 504 @',
      'Http.NetworkError @'
    ]
    const validError = messages.some(message => error.errorMessage.includes(message))

    return component && validError
  })
}

// Postcode modal
function buildValidationRules (form, key) {
  const quotesSiteUrl = (form.dataset.quotesSiteUrl === '/') ? '' : form.dataset.quotesSiteUrl

  return {
    [key]: {
      presence: {
        message: form.dataset.translationValidPostcodeRequired
      },
      validPostcode: {
        message: form.dataset.translationValidPostcodeRequired,
        url: `${quotesSiteUrl}/postcode_sectors/check-postcode`
      }
    }
  }
}

function updateLocationPorts (ports) {
  document.addEventListener('DOMContentLoaded', () => {
    const postcodeForm = document.querySelector('#stock-search-postcode-form')

    if (!postcodeForm) return

    const quotesSiteUrl = (postcodeForm.dataset.quotesSiteUrl === '/') ? '' : postcodeForm.dataset.quotesSiteUrl
    const postcodeInput = document.querySelector('#stock-search-postcode')
    const postcodeFromCookie = Cookie.get('user_postcode')
    const postcodeSubmit = document.querySelector('#stock-search-postcode-submit')

    // If a user location cookie has already been set,
    // update the value of the location form.
    if (postcodeFromCookie) {
      postcodeInput.value = postcodeFromCookie
    }

    if (postcodeInput.value && postcodeFromCookie) {
      postcodeSubmit.classList.add('btn--disabled')
      postcodeSubmit.setAttribute('disabled', true)
    }

    postcodeInput.addEventListener('input', () => {
      postcodeSubmit.classList.remove('btn--disabled')
      postcodeSubmit.removeAttribute('disabled')
    })

    const rules = buildValidationRules(postcodeForm, 'stock-search-postcode')

    initFormValidation(postcodeForm, rules, {
      async: true,
      submitHandler: () => {
        postcodeInput.value = postcodeInput.value.toUpperCase()

        const postcode = postcodeInput.value
        const domain = document.domain.replace(/^.*.carwow/, 'carwow')

        fetch(quotesSiteUrl + '/postcode_sectors/postcode-location?postcode=' + postcode)
          .then(response => response.json())
          .then(response => {
            const coordinates = JSON.stringify([response.latitude, response.longitude])

            Cookie.set('user_postcode', postcode, { expires: 30, domain })

            ports.locationChanged.send({
              postcode,
              coordinates
            })
          })
      }
    })
  })
}

function getAllSarchParams () {
  const allSearchParams = []
  const urlParams = new URL(window.location.href).searchParams
  const entries = urlParams.entries()

  for (const entry of entries) {
    allSearchParams.push(entry)
  }

  return allSearchParams
}

document.addEventListener('DOMContentLoaded', () => {
  const postcodeFormLoggedIn = document.querySelector('#postcode-form-when-logged-in')
  if (!postcodeFormLoggedIn) return

  const rules = buildValidationRules(postcodeFormLoggedIn, 'user[postcode]')
  initFormValidation(postcodeFormLoggedIn, rules, { async: true })
})
